import type { LinkProps as MuiLinkProps } from '@mui/material/Link';
import MuiLink from '@mui/material/Link';

import type { LinkProps as RouterLinkProps } from '@tanstack/react-router';
import { Link as RouterLink } from '@tanstack/react-router';
import React from 'react';

type Props = Omit<MuiLinkProps, 'href' | 'component'> & {
  state?: RouterLinkProps['state'];
  to?: RouterLinkProps['to'];
  href?: string;
  children?: React.ReactNode;
};

const Link = React.forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  const { to, href, children, ...restProps } = props;
  if (to) {
    return (
      <MuiLink
        ref={ref}
        to={to}
        component={RouterLink}
        activeOptions={{ exact: true }}
        activeProps={{ className: 'Mui-active' }}
        {...restProps}
      >
        {children}
      </MuiLink>
    );
  }

  if (href) {
    return (
      <MuiLink ref={ref} href={href} component="a" {...restProps}>
        {children}
      </MuiLink>
    );
  }

  throw new Error("Provide 'to' or 'href'.");
});

Link.displayName = 'Link';
export default Link;
